import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { resendConfirmationEmail } from "../components/loginAPI";
import { defineStore } from "pinia";
import { ref } from "vue";
export var useEmailConfirmStore = defineStore("emailConfirmStoreId", () => {
  var passwordToken = ref("");
  var publicUserEmailConfirmSuccess = ref(null);
  var setPasswordToken = newVal => {
    if (newVal !== undefined) {
      passwordToken.value = "";
      history.pushState(null, "", "/");
      return;
    }
    var curURL = new URL(window.location.href);
    passwordToken.value = curURL.searchParams.get("token") || "";
  };
  var verifyEmail = email => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield resendConfirmationEmail(email);
      publicUserEmailConfirmSuccess.value = true;
      return true;
    } catch (err) {
      console.error(err);
      publicUserEmailConfirmSuccess.value = false;
      return false;
    }
  });
  return {
    passwordToken,
    publicUserEmailConfirmSuccess,
    setPasswordToken,
    verifyEmail
  };
});